'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var formik = require('formik');
var classNames = require('classnames/bind');
var RadioGroupContext = require('./RadioGroupContext.js');
var RadioGroup_module = require('./RadioGroup.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(RadioGroup_module["default"]);
var RadioGroup = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.row, row = _b === void 0 ? false : _b, fieldProps = _tslib.__rest(_a, ["children", "className", "row"]);
    var _c = formik.useField(fieldProps)[0], name = _c.name, value = _c.value, onChange = _c.onChange;
    var groupRef = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({
        focus: function () {
            if (groupRef.current) {
                var input = groupRef.current.querySelector('input:not(:disabled):checked');
                if (!input) {
                    input = groupRef.current.querySelector('input:not(:disabled)');
                }
                if (input) {
                    input.focus();
                }
            }
        },
    }); }, []);
    return (jsxRuntime.jsx(RadioGroupContext["default"].Provider, _tslib.__assign({ value: { name: name, onChange: onChange, value: value } }, { children: jsxRuntime.jsx("div", _tslib.__assign({ role: "radiogroup", className: cx(RadioGroup_module["default"].radioGroup, row, className), ref: groupRef }, { children: children })) })));
});

exports["default"] = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map
